import { useGetApiV1CourseregistrationSharedClassStudentList } from '@/shared/api/generated';
import { mapDropdownOptions, useDebouncedFilter } from '@/shared/ui/molecules/LookupAutocomplete';

/**
 * Busca de turmas por texto (debounce de 1 s + mínimo de 3 caracteres) para o
 * autocomplete de turma. Consome o lookup
 * `courseregistration/shared/class-student-list`.
 *
 * @param filter - Texto digitado no campo (default `''`).
 * @returns `{ options, isLoading, isQuerySuccess }`.
 */
export function useClassStudentSearchDropdown(filter = '') {
  const { debouncedFilter, isReady } = useDebouncedFilter(filter);

  const { data, isLoading, isSuccess } = useGetApiV1CourseregistrationSharedClassStudentList(
    isReady ? { filter: debouncedFilter } : undefined,
    { query: { enabled: isReady } },
  );

  return { options: mapDropdownOptions(data), isLoading, isQuerySuccess: isSuccess } as const;
}
